/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useContext, useEffect, useRef } from 'react';
import { mapValues, cloneDeep, some } from 'lodash';
import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '@material-ui/core/Button';
import { Loader, renderTaggedPrintNotes } from '@mummssoftware/common-ui';
import { formatPostDate } from '@mummssoftware/utils/formatters';
import {
  delay,
  getInputEngine,
  isElectionAddendumForm,
} from '@mummssoftware/utils/utils';
import {
  GlobalContext,
  FormsGlobalContext,
  SET_FAJITA_QUESTIONNAIRE_FORM,
  VisitsGlobalContext,
} from '@mummssoftware/global-context';

import {
  Submitted,
  Autosave,
  Discard,
  FAJITA,
  HospiceElectionStatement,
} from '@mummssoftware/utils/constants';
import { useInterval } from '@mummssoftware/utils/hooks';
import { useStyles } from './style';
import { FormPrompt } from './FormPrompt';
import {
  FormBody,
  ElementDiv,
  StyledUl,
  FormLi,
  TopFormSection,
  FullWidthLi,
  SavingDiv,
  TitleDiv,
  StickyTitleDiv,
} from './WrapperDiv';
import {
  isonerequired,
  FormProps,
  horizontal,
  statement,
  label,
  input,
  date,
  signature,
  radio,
  singleselect,
  multiselect,
  checkbox,
  map,
  widthMultiplier,
  topFormSectionID,
} from './constants';
import {
  LabelField,
  InputField,
  DateField,
  StatementField,
  CheckBoxField,
  SelectField,
  MultiSelectField,
  RadioField,
  DCButton,
} from './Field';
import { FormSignature } from './FormSignature';
import PainMap from './PainMap';
import {
  createFormData,
  updateElementBis,
  updateFalseNodes,
  createGlobalTypeState,
  createEditInitSubmitState,
  createGolbalEditInitState,
  createEditInitLabelState,
  createGlobalInitIds,
  unselectElement,
  unselectId,
  getRadioParent,
  createInitState,
  createInitSubmitState,
  cleanSubmittedState,
  updateDCElement,
  updateChildDCNodes,
  createGolbalDCInitState,
  updateStatementNodes,
  updateElectionAddendumNodes,
  checkRequired,
  cleanFormSubmission,
  createParentGlobalRequiredQuestState,
  createParentGlobalDisabledState,
  hasBeenClicked,
  isTitleUI,
} from './utils';
import { FajitaContext } from '../../FajitaForms/Context';
import { Context } from '../../../context';
import {
  HAS_FORM_BEEN_MODIFIED,
  SUBMIT_PLAN,
  SET_SUBMIT_PLAN_ACTIVE,
  DISCARD_FORM,
  SET_REQ_QUEST,
  SHOW_REQ_SWITCH,
  SET_PARSING_FORM_ERROR,
  SHOW_STICKIES,
} from '../../FajitaForms/Context/constants';
import defaults from '../../../translations/en.json';
// import { data3 } from '../data/data3';
import './style/style.css';

export const FormRenderer = ({ formData }: FormProps) => {
  const { fajitaQuestionnaireFormGlobal } = useContext(FormsGlobalContext);
  const { appVisit } = useContext(GlobalContext);
  const { providerInfo } = useContext(VisitsGlobalContext);
  const { dispatchQuestionnaire } = useContext(FormsGlobalContext);
  const {
    currentUser,
    patient,
    agency,
    siteId,
    saveFajitaForm,
    updateFajitaFormCache,
    setError,
    formCache,
    readOnlyForm,
    removeReadOnlyForm,
  } = useContext(Context);
  const {
    submitPlan,
    discardForm,
    formModified,
    reqQuest,
    reqSwitch,
    parsingFormError,
    dispatch,
  } = useContext(FajitaContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [reloadKey, setReloadKey] = useState<number>(0);
  const isSubmittingRef = useRef(false);

  const resetSubmitInProgress = () => {
    isSubmittingRef.current = false;
    dispatch({
      type: SET_SUBMIT_PLAN_ACTIVE,
      payload: false,
    });
  };
  // eslint-disable-next-line prefer-destructuring
  const isSticky = (formData as any).isSticky;
  const formName = formData ? formData.name || formData.formname : 'Form';

  const isInProgressFAJITA = fajitaQuestionnaireFormGlobal?.isInProgressFAJITA;
  // from saving the form and VIEW on dropdown
  const readOnly = readOnlyForm || formData.readonly;
  const autoSaveEnabled: boolean = window.env?.autoSaveEnabled as boolean;

  // submit Form dispatched from Widget Header
  useEffect(() => {
    if (submitPlan) {
      onSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitPlan]);

  const [updatedData, setUpdatedData] = useState<any>(null);

  // on initial load
  useEffect(() => {
    const parsedFormData = createFormData(formData);

    // const parsedFormData = createFormData({
    //   formdefinition: data3,
    // });

    if (parsedFormData) {
      setUpdatedData(parsedFormData);
      dispatch({
        type: SET_PARSING_FORM_ERROR,
        payload: false,
      });
    } else {
      dispatch({
        type: SET_PARSING_FORM_ERROR,
        payload: true,
      });
    }
  }, []);

  useEffect(() => {
    if (parsingFormError) {
      const parsedFormData = createFormData(formData);

      if (parsedFormData) {
        setUpdatedData(parsedFormData);
        dispatch({
          type: SET_PARSING_FORM_ERROR,
          payload: false,
        });
      } else {
        dispatch({
          type: SET_PARSING_FORM_ERROR,
          payload: true,
        });
      }
    }
  }, [parsingFormError]);

  const [initIds, setInitIds] = useState<any>(null);
  const [initGroupBoxState, setInitGroupBoxState] = useState<any>(null);
  const [initSubmitGroupBoxState, setInitSubmitGroupBoxState] = useState<any>(
    null,
  );
  const [initLabelGroupBoxState, setInitLabelGroupBoxState] = useState<any>(
    null,
  );
  const [initDCGroupBoxState, setInitDCGroupBoxState] = useState<any>(null);

  const [hasReqQuest, setHasReqQuest] = useState<boolean>(false);
  // used for INA PAIN conditional rendering
  const [disabledState, setDisabledState] = useState<any>(null);
  // todo add formData?.id and remove all uneceassary state updates
  useEffect(() => {
    if (updatedData) {
      const initids = createGlobalInitIds(updatedData);
      initids && setInitIds(initids);
      // first we do the initFirstGroupBoxState = EDITING groupBoxState
      // if groupBoxState is {} then this means this is a NEW form
      const initFirstGroupBoxState = createGolbalEditInitState(updatedData);
      const isEditData = !!Object.keys(initFirstGroupBoxState).length;
      const initgroupBoxState = isEditData
        ? initFirstGroupBoxState
        : createInitState(updatedData);
      initgroupBoxState && setInitGroupBoxState(initgroupBoxState);
      const initsubmitGroupBoxState = isEditData
        ? createEditInitSubmitState(initgroupBoxState)
        : createInitSubmitState(updatedData);
      initsubmitGroupBoxState &&
        setInitSubmitGroupBoxState(initsubmitGroupBoxState);
      const initlabelGroupBoxState = isEditData
        ? createEditInitLabelState(initgroupBoxState)
        : {};
      initlabelGroupBoxState &&
        setInitLabelGroupBoxState(initlabelGroupBoxState);
      const initdcGroupBoxState = isEditData
        ? createGolbalDCInitState(updatedData)
        : {};
      initdcGroupBoxState && setInitDCGroupBoxState(initdcGroupBoxState);
      // required questions
      const requiredQuestState = createParentGlobalRequiredQuestState(
        updatedData,
      );
      // disabled quest state
      const disabledQuestState = createParentGlobalDisabledState(updatedData);
      disabledQuestState && setDisabledState(disabledQuestState);
      if (requiredQuestState) {
        // this is a number
        const numQuestRequired = Object.keys(requiredQuestState)
          ? Object.keys(requiredQuestState).length
          : 0;
        dispatch({
          type: SET_REQ_QUEST,
          payload: !!numQuestRequired,
        });

        if (reqSwitch) {
          dispatch({
            type: SHOW_REQ_SWITCH,
            payload: !!numQuestRequired,
          });
        }

        setHasReqQuest(!!numQuestRequired);
      }
      // control type state
      const controltypeState = createGlobalTypeState(updatedData);
      setControlTypeState(controltypeState);
    }
  }, [updatedData]);

  const initState = cloneDeep(initGroupBoxState);
  const [selectedIds, setSelectedIds] = useState<any>(initIds);
  const [groupBoxState, setGroupBoxState] = useState<any>(initState);
  const [labelState, setLabelState] = useState<any>(initLabelGroupBoxState);
  const [submitGroupBoxState, setSubmitGroupBoxState] = useState<any>(
    initSubmitGroupBoxState,
  );
  const [submitButtonState, setSubmitButtonState] = useState<any>({});
  const [dcGroupBoxState, setDCGroupBoxState] = useState<any>(
    initDCGroupBoxState,
  );
  const [controlTypeState, setControlTypeState] = useState<any>({});

  /**
   * SET INIT STATES
   */
  useEffect(() => {
    if (initGroupBoxState) {
      setGroupBoxState(initGroupBoxState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initGroupBoxState && Object.keys(initGroupBoxState)[0]]);

  useEffect(() => {
    if (initSubmitGroupBoxState) {
      setSubmitGroupBoxState(initSubmitGroupBoxState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initSubmitGroupBoxState && Object.keys(initSubmitGroupBoxState)[0]]);

  useEffect(() => {
    if (initIds) {
      setSelectedIds(initIds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initIds && Object.keys(initIds)[0]]);

  useEffect(() => {
    if (initDCGroupBoxState) {
      setDCGroupBoxState(initDCGroupBoxState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initDCGroupBoxState && Object.keys(initDCGroupBoxState)[0]]);

  useEffect(() => {
    if (initLabelGroupBoxState) {
      setLabelState(initLabelGroupBoxState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initLabelGroupBoxState && Object.keys(initLabelGroupBoxState)[0]]);

  // todo with updateddata
  useEffect(() => {
    // reset all the states if change of form
    if (initIds) {
      setSelectedIds(initIds);
    }
    if (initSubmitGroupBoxState) {
      setSubmitGroupBoxState(initSubmitGroupBoxState);
    }
    if (initGroupBoxState) {
      setGroupBoxState(initGroupBoxState);
    }
    if (initDCGroupBoxState) {
      setDCGroupBoxState(initDCGroupBoxState);
    }
    if (initLabelGroupBoxState) {
      setLabelState(initLabelGroupBoxState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.id]);

  // helpful do not remove
  // console.log('***FormRenderer***');
  // console.log('***updatedData***', updatedData);
  // console.log('*groupBoxState*', groupBoxState);
  // console.log('*selectedIds*', selectedIds);
  // console.log('**dcGroupBoxState**', dcGroupBoxState);
  // console.log('***submitGroupBoxState***', submitGroupBoxState);
  // console.log('***submitButtonState***', submitButtonState);

  // ******************************************************
  // @note VISIT if a visit is being recorded save date and id

  const { formkey, name, id } = formData;
  const formId = fajitaQuestionnaireFormGlobal?.isInProgressFAJITA
    ? id
    : formCache
    ? formCache.id
    : '';

  // Created User data should not be overwritten
  // if edit form keep the original data
  const createdFormData = formData.createpersonid
    ? {
        createdatetime: formData.createdatetime,
        createpersonid: formData?.createpersonid?.toString() as string,
        createpersonnumber: formData?.createpersonnumber as string,
      }
    : {
        createdatetime: formatPostDate(Date.now()),
        createpersonid: currentUser?.userId?.toString() as string,
        createpersonnumber: currentUser?.personNumber as string,
      };

  const submissionFormData = {
    id: formId,
    modifieddatetime: formatPostDate(Date.now()),
    modifiedpersonid: currentUser?.userId?.toString() as string,
    modifiedpersonnumber: currentUser?.personNumber as string,
    formname: (name || formData.formname) as string,
    manifesttype: formData?.manifesttype,
    patientnumber: patient ? patient.patientNumber : formData.patientnumber,
    siteid: siteId as string,
    source: formData?.source,
    sourcekey: '',
    formkey: formkey as string,
    // timezone: tz as string,
    url: '',
    urltype: formData?.urltype,
    patientvisit_id: formData.patientvisit_id,
    visitdatetime: formData.visitdatetime,
    ...createdFormData,
    // if in a visit, pass the selected role
    role_id: formData?.role_id,
    sticky: formData?.sticky || false,
  };
  // ******************************************************

  /**
   * SUBMIT BUTTON STATE
   */
  useEffect(() => {
    if (some(Object.values(submitButtonState), (x) => x === true)) {
      // change registered on the form determines if exit the form without saving or need to save
      !formModified &&
        dispatch({
          type: HAS_FORM_BEEN_MODIFIED,
          payload: true,
        });
    }
  }, [JSON.stringify(Object.values(submitButtonState))]);

  /**
   * AUTO SAVING 2 min 2*60*1000
   */
  const [delaySave, setSaveDelay] = useState<number | null>(120000);

  useEffect(() => {
    // if the form is submitted or discarded the interval is cleared
    if (discardForm || submitPlan) {
      setSaveDelay(null);
    }
  }, [discardForm, submitPlan]);

  // useInterval so that the submissionForm captures the latest state
  useInterval(
    () => {
      // if a change has been registered on the form can start auto saving
      // the moment a change has been registered on the form, the interval is created
      // saveFormCache is called every 5 minutes
      if (autoSaveEnabled && formModified) {
        saveFormCache();
      }
    },
    // Delay in milliseconds or null to stop it
    delaySave,
  );

  const saveFormCache = () => {
    const submissionForm = {
      ...submissionFormData,
      formsubmissionautosave: JSON.stringify(submitGroupBoxState),
      status: Autosave,
    };
    updateFajitaFormCache(submissionForm, agency as string);
  };

  const deleteFormCache = () => {
    const submissionForm = {
      ...submissionFormData,
      status: Discard,
    };

    updateFajitaFormCache(submissionForm, agency as string);
  };
  /**
   * DISCARD FORM
   */
  useEffect(() => {
    if (discardForm) {
      // if form WIP or sticky and auto saved
      if ((isInProgressFAJITA || isSticky) && formCache) {
        deleteFormCache();
      }
      // when discard stop auto saving
      // when discard exit the form without save WIP
      dispatch({
        type: HAS_FORM_BEEN_MODIFIED,
        payload: false,
      });
      dispatch({
        type: DISCARD_FORM,
        payload: false,
      });
    }
  }, [discardForm, formCache]);

  const updateSubmitState = (el: any) => {
    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    updatedSubmitGroupBoxState[el.questionpath] = true;
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);
  };

  /** handle Checkbox Change */
  const handleCheckboxChange = (
    event: any,
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    /** update selectedIds */
    const updatedArray = [...selectedIds];
    if (updatedArray[depthLevel]) {
      const index = updatedArray[depthLevel].indexOf(questionpath);
      // if you are SELECTING UI
      if (index === -1) {
        updatedArray[depthLevel].push(questionpath);
      } else {
        // if you are UNSELECTING UI
        updatedArray[depthLevel].splice(index, 1);
        // for all level downs, splice it if includes questionpath
        unselectId(updatedArray, depthLevel, questionpath);
      }
    } else {
      updatedArray[depthLevel] = [questionpath];
    }
    setSelectedIds(updatedArray);

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    updatedSubmitGroupBoxState[questionpath] = event.target.checked;
    if (event.target.checked) {
      if (!updatedSubmitGroupBoxState[parentquestionpath]) {
        updatedSubmitGroupBoxState[parentquestionpath] = true;
      }
    }
    if (!event.target.checked) {
      // remove children
      cleanSubmittedState(updatedSubmitGroupBoxState, questionpath);
    }
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update submitButtonState */

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };
    updatedSubmitButtonState[questionpath] = event.target.checked;
    if (!event.target.checked) {
      // remove children
      cleanSubmittedState(updatedSubmitButtonState, questionpath);
    }
    setSubmitButtonState(updatedSubmitButtonState);

    /** update dcGroupBoxState */

    // means we could be UN-DC an item
    // todo need to be able to remove dc date
    if (event.target.checked && dcGroupBoxState[questionpath]) {
      const updatedDcGroupBoxState = {
        ...dcGroupBoxState,
      };

      // remove the DC item from the state
      // logic when saving data to remove dc date and children if event target checked

      delete updatedDcGroupBoxState[questionpath];
      setDCGroupBoxState(updatedDcGroupBoxState);
    }

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };
    if (updatedGroupBoxState[parentquestionpath]) {
      updatedGroupBoxState[parentquestionpath][questionpath] =
        event.target.checked;
    } else {
      // potential text entry delay fix
      updatedGroupBoxState[parentquestionpath] = {};
      updatedGroupBoxState[parentquestionpath][questionpath] =
        event.target.checked;
    }
    // if you are SELECTING
    if (event.target.checked) {
      updatedGroupBoxState[questionpath] = {};
    } else {
      // if you are UNSELECTING
      // all children are now false
      unselectElement(updatedGroupBoxState, questionpath);
    }

    setGroupBoxState(updatedGroupBoxState);
  };

  /** handleDCdChange */
  const handleDCdChange = (
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    // UPDATE UI AND SUBMIT STATE
    /** update selectedIds */
    const updatedArray = [...selectedIds];
    // will always be the case
    if (updatedArray[depthLevel]) {
      const index = updatedArray[depthLevel].indexOf(questionpath);
      updatedArray[depthLevel].splice(index, 1);
      // for all level downs, splice it if includes questionpath
      unselectId(updatedArray, depthLevel, questionpath);
    }
    setSelectedIds(updatedArray);

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    updatedSubmitGroupBoxState[questionpath] = false;
    cleanSubmittedState(updatedSubmitGroupBoxState, questionpath);
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };
    updatedGroupBoxState[parentquestionpath][questionpath] = false;

    // all children are now false
    unselectElement(updatedGroupBoxState, questionpath);

    setGroupBoxState(updatedGroupBoxState);

    // UPDATE DC STATE

    /** update dcGroupBoxState */

    const updatedDcGroupBoxState = {
      ...dcGroupBoxState,
    };
    updatedDcGroupBoxState[questionpath] = true;
    // means all the children items are DC
    setDCGroupBoxState(updatedDcGroupBoxState);

    /** update submitButtonState */

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };
    updatedSubmitButtonState[questionpath] = true;

    setSubmitButtonState(updatedSubmitButtonState);
  };

  /** handle DC Checkbox Change */
  const handleDCChange = (
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    // race error?
    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    // @note please do not remove
    console.log('handleDCChange', updatedSubmitGroupBoxState[questionpath]);
    // you can DC an item that has been checked
    if (updatedSubmitGroupBoxState[questionpath]) {
      handleDCdChange(depthLevel, parentquestionpath, questionpath);
    }
  };

  /** handle Select Change */
  const handleSelectChange = (
    event: any,
    depthLevel: number,
    parentquestionpath: string,
  ) => {
    const questionpath = event.target.value;
    /** update submitButtonState */
    // @note change an item in multi select should trigger the submit button

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    updatedSubmitGroupBoxState[questionpath] = true;
    if (!updatedSubmitGroupBoxState[parentquestionpath]) {
      updatedSubmitGroupBoxState[parentquestionpath] = true;
    }

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };
    // if nothing selected we can assume updatedGroupBoxState[parentquestionpath] = {}
    // if something already selected => updatedGroupBoxState[parentquestionpath] = {'27571->25005->25609': true}
    const stateArray = Object.keys(updatedGroupBoxState[parentquestionpath]);
    // If something has already been selected
    if (stateArray.length) {
      const key = stateArray[0];
      // remove the previous choice from updatedGroupBoxState
      delete updatedGroupBoxState[key];
      // update the previous choice from updatedSubmitGroupBoxState to false
      // so that the previous choice is being removed
      updatedSubmitGroupBoxState[key] = false;
      // update w current choice
      updatedGroupBoxState[parentquestionpath] = {};
      updatedGroupBoxState[parentquestionpath][questionpath] = true;
      updatedGroupBoxState[questionpath] = {};
      // the submit button should be triggered
      updatedSubmitButtonState[questionpath] = true;
    } else {
      updatedGroupBoxState[parentquestionpath][questionpath] = true;
      updatedGroupBoxState[questionpath] = {};
    }

    setGroupBoxState(updatedGroupBoxState);
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);
    setSubmitButtonState(updatedSubmitButtonState);
  };

  /** handle Multi Select Change */
  const handleMultiSelectChange = (
    event: any,
    depthLevel: number,
    parentquestionpath: string,
  ) => {
    // if select 2 checkbox
    // event.target.value is  ['27571->25005->25609','27571->25005->25608']
    // if remove 1 checkbox event.target.value is  ['27571->25005->25609']
    // the one removed is not tracked anymore
    // but it needs to be removed from updatedGroupBoxState[questionpath]
    // if stateArray has an element that  event.target.value does not, need to remove it from updatedGroupBoxState
    const questionpaths = event.target.value;
    // TODO UPDATE ALL OTHER STATES

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    if (!updatedSubmitGroupBoxState[parentquestionpath]) {
      updatedSubmitGroupBoxState[parentquestionpath] = true;
    }

    /** update submitButtonState */
    // @note change an item in multi select should trigger the submit button

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };

    // if nothing selected we can assume updatedGroupBoxState[parentquestionpath] = {}
    // if something already selected => updatedGroupBoxState[parentquestionpath] = {'27571->25005->25609': true,'27571->25005->25608': true}
    const stateArray = Object.keys(updatedGroupBoxState[parentquestionpath]);
    // stateArray.length should be less than questionpaths.length BUT if an element has been removed

    if (stateArray.length) {
      stateArray.forEach((path: string) => {
        // it means the element has been removed
        if (!questionpaths.includes(path)) {
          // remove the previous choice from updatedGroupBoxState
          delete updatedGroupBoxState[path];
          // update the previous choice from updatedSubmitGroupBoxState to false
          // so that the previous choice is being removed
          updatedSubmitGroupBoxState[path] = false;
          // the submit button should be triggered
          updatedSubmitButtonState[path] = true;
        }
      });
    }

    // reset GROUP BOX STATE
    updatedGroupBoxState[parentquestionpath] = {};

    // update the updatedGroupBoxState
    questionpaths.forEach((path: string) => {
      updatedGroupBoxState[parentquestionpath][path] = true;
      updatedGroupBoxState[path] = {};
    });

    // update the updatedSubmitGroupBoxState
    questionpaths.forEach((path: string) => {
      if (!stateArray.includes(path)) {
        // then update with new selected element
        updatedSubmitGroupBoxState[path] = true;
        // the submit button should be triggered
        updatedSubmitButtonState[path] = true;
      }
    });

    setGroupBoxState(updatedGroupBoxState);
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);
    setSubmitButtonState(updatedSubmitButtonState);
  };

  /** handle Radio Change */
  const handleRadioChange = (
    event: any,
    depthLevel: number,
    subqchoice: mumms.FajitaNode,
  ) => {
    const { parentquestionpath, questionpath, dp, ap } = subqchoice;

    const updatedGroupBoxState = {
      ...groupBoxState,
    };

    // potential text entry delay fix
    if (!updatedGroupBoxState[parentquestionpath]) {
      updatedGroupBoxState[parentquestionpath] = {};
    }
    // needed in 2nd and 3rd scenario
    let radioSelectedPath: string | null = null;

    // First of all, if UNSELECTING a radio
    if (updatedGroupBoxState[questionpath]) {
      // this means the radio is already selected
      updatedGroupBoxState[parentquestionpath][questionpath] = false;
      radioSelectedPath = questionpath;
      unselectElement(updatedGroupBoxState, questionpath);
    } else if (!Object.keys(updatedGroupBoxState[parentquestionpath])) {
      // if first time clicking on radio button
      updatedGroupBoxState[parentquestionpath][questionpath] = true;
      updatedGroupBoxState[questionpath] = {};
    } else {
      // there might already have a radio button selected

      /** get all Radio Elements */
      const radioParent = getRadioParent(updatedData, parentquestionpath);
      const radioChildren = radioParent.subqchoices
        .filter((item: any) => item.controltype === radio)
        .map((item: any) => item.questionpath);

      // is any of the radio selected
      radioChildren.forEach((path: string) => {
        if (updatedGroupBoxState[path]) {
          radioSelectedPath = path;
        }
        return null;
      });

      if (radioSelectedPath) {
        // if a radio child is already selected need to unselect it
        updatedGroupBoxState[parentquestionpath][radioSelectedPath] = false;
        unselectElement(updatedGroupBoxState, radioSelectedPath);
        // then check the one that has been clicked
        updatedGroupBoxState[parentquestionpath][questionpath] = true;
        updatedGroupBoxState[questionpath] = {};
      } else {
        updatedGroupBoxState[parentquestionpath][questionpath] = true;
        updatedGroupBoxState[questionpath] = {};
      }
    }

    /** update RADIO groupBoxState */

    setGroupBoxState(updatedGroupBoxState);

    /** update selectedIds */

    const updatedArray = [...selectedIds];
    if (updatedArray[depthLevel]) {
      // if a radio child is already selected need to unselect it
      if (radioSelectedPath) {
        const index = updatedArray[depthLevel].indexOf(radioSelectedPath);
        updatedArray[depthLevel].splice(index, 1);
        // for all level downs, splice it if includes questionpath
        unselectId(updatedArray, depthLevel, radioSelectedPath);
      }
      // add it
      updatedArray[depthLevel].push(questionpath);
    } else {
      updatedArray[depthLevel] = [questionpath];
    }

    setSelectedIds(updatedArray);

    /** update disabledState
     * This is for INA PAIN setion, conditional rendering
     */
    if (ap && (disabledState[ap] === true || disabledState[ap] === false)) {
      const updatedDisabledState = {
        ...disabledState,
      };
      // already selected radio button YES
      if (submitGroupBoxState[questionpath]) {
        updatedDisabledState[ap] = true;
      } else {
        updatedDisabledState[ap] = false;
      }
      setDisabledState(updatedDisabledState);
    }
    if (dp && (disabledState[dp] === true || disabledState[dp] === false)) {
      const updatedDisabledState = {
        ...disabledState,
      };
      updatedDisabledState[dp] = true;

      setDisabledState(updatedDisabledState);
    }

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };

    // UNSELECTING the radio button
    if (updatedSubmitGroupBoxState[questionpath]) {
      updatedSubmitGroupBoxState[questionpath] = false;
    } else {
      // RADIO BUTTON ALREADY SELECTED
      if (radioSelectedPath) {
        updatedSubmitGroupBoxState[radioSelectedPath] = false;
        cleanSubmittedState(updatedSubmitGroupBoxState, radioSelectedPath);
      }
      updatedSubmitGroupBoxState[questionpath] = true;
      if (!updatedSubmitGroupBoxState[parentquestionpath]) {
        updatedSubmitGroupBoxState[parentquestionpath] = true;
      }
    }

    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update dcGroupBoxState */

    // means we could be UN-DC an item
    // todo need to be able to remove dc date
    if (event.target.checked && dcGroupBoxState[questionpath]) {
      const updatedDcGroupBoxState = {
        ...dcGroupBoxState,
      };

      // remove the DC item from the state
      // logic when saving data to remove dc date and children if event target checked

      delete updatedDcGroupBoxState[questionpath];
      setDCGroupBoxState(updatedDcGroupBoxState);
    }

    /** update submitButtonState */

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };

    updatedSubmitButtonState[questionpath] = true;

    setSubmitButtonState(updatedSubmitButtonState);
  };

  /** handle Date Change */

  const handleDateChange = (
    event: any,
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    const textValue = event;
    /** update selectedIds */
    const updatedArray = [...selectedIds];
    if (updatedArray[depthLevel]) {
      const index = updatedArray[depthLevel].indexOf(questionpath);
      // if you are SELECTING
      if (index === -1) {
        updatedArray[depthLevel].push(questionpath);
      } else {
        // if you are UNSELECTING
        updatedArray[depthLevel].splice(index, 1);
      }
    } else {
      updatedArray[depthLevel] = [questionpath];
    }
    setSelectedIds(updatedArray);

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    if (!updatedSubmitGroupBoxState[parentquestionpath]) {
      updatedSubmitGroupBoxState[parentquestionpath] = true;
    }

    updatedSubmitGroupBoxState[questionpath] = textValue;
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };

    updatedGroupBoxState[parentquestionpath][questionpath] = textValue;
    // if you are SELECTING
    if (textValue && !updatedGroupBoxState[parentquestionpath][questionpath]) {
      updatedGroupBoxState[questionpath] = {};
    } else {
      // if you are UNSELECTING
      // all children are now false
      updatedGroupBoxState[questionpath] = mapValues(
        updatedGroupBoxState[questionpath],
        () => false,
      );
    }

    setGroupBoxState(updatedGroupBoxState);

    /** update submitButtonState */

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };
    // the submit button should be triggered
    updatedSubmitButtonState[questionpath] = true;
    setSubmitButtonState(updatedSubmitButtonState);
  };

  /** handle Signature Change */

  const handleURLChange = (
    event: any,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    const signatureValue = event;
    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    if (!updatedSubmitGroupBoxState[parentquestionpath]) {
      updatedSubmitGroupBoxState[parentquestionpath] = true;
    }

    updatedSubmitGroupBoxState[questionpath] = signatureValue;
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };

    updatedGroupBoxState[parentquestionpath][questionpath] = signatureValue;
    setGroupBoxState(updatedGroupBoxState);
  };

  /** handle Signature Clear */

  const handleURLClear = (parentquestionpath: string, questionpath: string) => {
    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };

    delete updatedSubmitGroupBoxState[questionpath];
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };

    delete updatedGroupBoxState[parentquestionpath][questionpath];
    setGroupBoxState(updatedGroupBoxState);
  };

  /** handle Input Change */

  const handleInputChange = (
    inputValue: string,
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    /** clean up the string */
    const textValue = getInputEngine(inputValue);

    /** update selectedIds */
    const updatedArray = [...selectedIds];
    if (updatedArray[depthLevel]) {
      const index = updatedArray[depthLevel].indexOf(questionpath);
      // if you are SELECTING
      if (index === -1) {
        updatedArray[depthLevel].push(questionpath);
      } else {
        // if you are UNSELECTING
        updatedArray[depthLevel].splice(index, 1);
      }
    } else {
      updatedArray[depthLevel] = [questionpath];
    }
    setSelectedIds(updatedArray);

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    if (!updatedSubmitGroupBoxState[parentquestionpath]) {
      updatedSubmitGroupBoxState[parentquestionpath] = true;
    }

    updatedSubmitGroupBoxState[questionpath] = textValue;
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };

    if (!updatedGroupBoxState[parentquestionpath]) {
      updatedGroupBoxState[parentquestionpath] = {};
    }
    updatedGroupBoxState[parentquestionpath][questionpath] = textValue;

    setGroupBoxState(updatedGroupBoxState);

    /** update submitButtonState */

    const updatedSubmitButtonState = {
      ...submitButtonState,
    };
    // the submit button should be triggered
    updatedSubmitButtonState[questionpath] = true;
    setSubmitButtonState(updatedSubmitButtonState);
  };

  /**
   * handle Label Change
   */

  const handleLabelChange = (
    expanded: boolean,
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    const checked = true;
    /** update selectedIds */
    const updatedArray = [...selectedIds];
    if (updatedArray[depthLevel]) {
      const index = updatedArray[depthLevel].indexOf(questionpath);
      if (index === -1) {
        updatedArray[depthLevel].push(questionpath);
      } else {
        updatedArray[depthLevel].splice(index, 1);
      }
    } else {
      updatedArray[depthLevel] = [questionpath];
    }
    setSelectedIds(updatedArray);

    /** update submitGroupBoxState */

    const updatedSubmitGroupBoxState = {
      ...submitGroupBoxState,
    };
    if (!updatedSubmitGroupBoxState[parentquestionpath]) {
      updatedSubmitGroupBoxState[parentquestionpath] = true;
    }

    updatedSubmitGroupBoxState[questionpath] = checked;
    setSubmitGroupBoxState(updatedSubmitGroupBoxState);

    /** update labelState */

    const updatedLabelState = {
      ...labelState,
    };

    updatedLabelState[questionpath] = { expanded };
    setLabelState(updatedLabelState);

    /** update groupBoxState */

    const updatedGroupBoxState = {
      ...groupBoxState,
    };

    // potential text entry delay fix
    if (!updatedGroupBoxState[parentquestionpath]) {
      updatedGroupBoxState[parentquestionpath] = {};
    }

    if (!updatedGroupBoxState[parentquestionpath][questionpath]) {
      updatedGroupBoxState[parentquestionpath][questionpath] = checked;
      updatedGroupBoxState[questionpath] = {};

      setGroupBoxState(updatedGroupBoxState);
    }
  };

  const autoUnroll = (
    depthLevel: number,
    parentquestionpath: string,
    questionpath: string,
  ) => {
    // @note autoUnroll is unfolding on INIT with multiple operations
    // @note not using copy of state or NOT updating
    // avoid multiple renders
    if (!groupBoxState[parentquestionpath]) {
      groupBoxState[parentquestionpath] = {};
    }
    if (!submitGroupBoxState[questionpath]) {
      submitGroupBoxState[questionpath] = true;
    }
    if (!groupBoxState[parentquestionpath][questionpath]) {
      const checked = true;
      /** update selectedIds */
      const updatedArray = [...selectedIds];
      if (updatedArray[depthLevel]) {
        const index = updatedArray[depthLevel].indexOf(questionpath);
        if (index === -1) {
          updatedArray[depthLevel].push(questionpath);
        } else {
          updatedArray[depthLevel].splice(index, 1);
        }
      } else {
        updatedArray[depthLevel] = [questionpath];
      }
      setSelectedIds(updatedArray);

      /** update groupBoxState */

      const updatedGroupBoxState = {
        ...groupBoxState,
      };

      const childrenPaths = Object.keys(
        updatedGroupBoxState[parentquestionpath],
      );

      if (!updatedGroupBoxState[parentquestionpath][questionpath]) {
        updatedGroupBoxState[questionpath] = {};
        updatedGroupBoxState[parentquestionpath][questionpath] = checked;

        childrenPaths.forEach((path) => {
          if (!updatedGroupBoxState[path]) {
            updatedGroupBoxState[path] = {};
          }
        });

        setGroupBoxState(updatedGroupBoxState);
      }

      /** update submitGroupBoxState */

      const updatedSubmitGroupBoxState = {
        ...submitGroupBoxState,
      };
      updatedSubmitGroupBoxState[questionpath] = checked;

      childrenPaths.forEach((path) => {
        if (!updatedSubmitGroupBoxState[path]) {
          updatedSubmitGroupBoxState[path] = checked;
        }
      });

      setSubmitGroupBoxState(updatedSubmitGroupBoxState);
    }
  };

  /**
   * handleRepeatEl
   */

  // const handleRepeatEl = (element: any) => {
  //   const size = updatedData.length;
  //   updatedData[size] = element;
  //   setUpdatedData(updatedData);
  //   setReloadKey(reloadKey + 1);
  // };

  /**
   * onSubmit
   */

  const onSubmit = async () => {
    if (isSubmittingRef.current) {
      return;
    }
    isSubmittingRef.current = true;
    dispatch({
      type: SET_SUBMIT_PLAN_ACTIVE,
      payload: true,
    });

    setIsLoading(true);
    // delay => getFormData is intensive data processing, break the loop for Loader to show
    // long-running operation
    await delay(500);
    if (submitPlan?.status === Submitted) {
      // if required fields
      if (reqQuest) {
        // check requiredState
        const data = cloneDeep(updatedData);
        const passTest = checkRequired(
          data,
          submitGroupBoxState,
          disabledState,
        );
        if (passTest) {
          await submitForm();
        } else {
          setIsLoading(false);
          setError({
            text: defaults.requiredFieldsError,
            severity: 'error',
          });
          // reset submit form to false
          dispatch({
            type: SUBMIT_PLAN,
            payload: null,
          });
          resetSubmitInProgress();
        }
      } else {
        await submitForm();
      }
    } else {
      await submitForm();
    }
  };

  const getFormData = () => {
    let newData = cloneDeep(updatedData);
    if (
      isElectionAddendumForm({
        formkey: formData?.formkey,
        formname: formName,
        name: formData?.name,
      })
    ) {
      newData = updateElectionAddendumNodes(newData);
    } else {
      // need to update the controltype STATEMENT value to true for backend to persist the data
      newData = updateStatementNodes(newData);
    }

    // **** Update answers ****
    // for each key in submitGroupBoxState, find it in updatedData and update value of items
    Object.keys(submitGroupBoxState).forEach((key) => {
      newData = updateElementBis(newData, key, submitGroupBoxState);
    });
    // update children to false if parent element is false- EDIT version
    newData = updateFalseNodes(newData);
    // console.log('newData', newData);

    // **** DC items *****
    // for each key in dcGroupBoxState, find it in updatedData and update dcdate
    Object.keys(dcGroupBoxState).forEach((key) => {
      newData = updateDCElement(newData, key, formatPostDate(Date.now()));
    });
    newData = updateChildDCNodes(newData, formatPostDate(Date.now()));

    // TODO ERROR : Patient Manifest could not be added

    const stringifyData = JSON.stringify(newData);
    const formsubmission = cleanFormSubmission(stringifyData);
    return formsubmission;
  };

  const submitForm = async () => {
    try {
      // takes many sec for INA Form
      const formsubmission = getFormData();

      const submissionForm = {
        ...submissionFormData,
        formsubmission,
        status: submitPlan ? submitPlan.status : Submitted,
        // todo requirednotenforced
        // form has required quest ? opposite of toggle answer : false
        requirednotenforced: hasReqQuest ? !reqQuest : false,
      };

      await saveFajitaForm(submissionForm, agency as string);

      setIsLoading(false);

      // reset submit form to false
      dispatch({
        type: SUBMIT_PLAN,
        payload: null,
      });
      // stop autosaving and exit the form
      dispatch({
        type: HAS_FORM_BEEN_MODIFIED,
        payload: false,
      });
      dispatch({
        type: SHOW_STICKIES,
        payload: null,
      });
      // Cross Platform
      if (!patient) {
        removeReadOnlyForm();
      }
      dispatch({
        type: SHOW_REQ_SWITCH,
        payload: false,
      });
      // reset Global fajita Form
      dispatchQuestionnaire({
        type: SET_FAJITA_QUESTIONNAIRE_FORM,
        payload: null,
      });
    } finally {
      resetSubmitInProgress();
    }
  };

  const renderField = (
    subqchoice: any,
    depthLevel: any,
    subMenu: any,
    // eslint-disable-next-line consistent-return
  ) => {
    switch (subqchoice.controltype) {
      // label cannot be DC
      case label:
        return (
          <ElementDiv
            key={`list-${subqchoice.id}`}
            id="cpp-label"
            className="formelement"
          >
            <FormLi
              key={`li-${subqchoice.id}`}
              id="cpp-li-label"
              horizontal={subqchoice.drawmode === horizontal}
            >
              <LabelField
                key={`field-${subqchoice.id}`}
                subqchoice={subqchoice}
                isExpanded={
                  (subqchoice.toporder === 1 && subqchoice.autounroll) ||
                  (labelState[subqchoice.questionpath] &&
                    labelState[subqchoice.questionpath].expanded) ||
                  false
                }
                onClick={(expanded: boolean) => {
                  handleLabelChange(
                    expanded,
                    depthLevel,
                    subqchoice.parentquestionpath,
                    subqchoice.questionpath,
                  );
                }}
                disabledState={disabledState}
                submittedState={submitGroupBoxState}
                required={reqQuest && subqchoice.required}
              />
              {/* {subqchoice.repeatable && (
                <Button
                  data-testid="als-button"
                  color="primary"
                  onClick={() => handleRepeatEl(subqchoice)}
                >
                  {`Repeat ${subqchoice.questionlabel}`}
                </Button>
              )} */}
              {subMenu}
            </FormLi>
          </ElementDiv>
        );
      // statement cannot be DC
      // TODO in read only forms statement should always show
      // @note: NOT IDEAL => 2 css bullet and title on diff part of UI
      case statement:
        return (
          <ElementDiv key={`list-${subqchoice.id}`} id="cpp-statement">
            <FormLi
              key={`li-${subqchoice.id}`}
              id="cpp-li-statement"
              horizontal={subqchoice.drawmode === horizontal}
              bullet={subqchoice.cssclass === 'bullet'}
            >
              <StatementField
                key={`field-${subqchoice.id}`}
                subqchoice={subqchoice}
              />
              {subMenu}
            </FormLi>
          </ElementDiv>
        );
      // INPUT cannot be DC
      case input:
        return (
          <ElementDiv key={`list-${subqchoice.id}`}>
            <FullWidthLi key={`li-${subqchoice.id}`}>
              <InputField
                key={`field-${subqchoice.id}`}
                // todo label or parentpatientlabel
                label={subqchoice.questionlabel}
                subqchoice={subqchoice}
                readOnly={readOnly}
                value={
                  groupBoxState[subqchoice.parentquestionpath] &&
                  groupBoxState[subqchoice.parentquestionpath][
                    subqchoice.questionpath
                  ]
                    ? groupBoxState[subqchoice.parentquestionpath][
                        subqchoice.questionpath
                      ]
                    : ''
                }
                handleChange={
                  readOnly
                    ? undefined
                    : (event: any) => {
                        handleInputChange(
                          event,
                          depthLevel,
                          subqchoice.parentquestionpath,
                          subqchoice.questionpath,
                        );
                      }
                }
                required={reqQuest && subqchoice.required}
              />
              {subMenu}
            </FullWidthLi>
          </ElementDiv>
        );
      case date:
        return (
          <ElementDiv key={`list-${subqchoice.id}`}>
            <li key={`li-${subqchoice.id}`}>
              <DateField
                key={`field-${subqchoice.id}`}
                // todo label or parentpatientlabel
                label={subqchoice.questionlabel}
                readOnly={readOnly}
                value={
                  groupBoxState[subqchoice.parentquestionpath] &&
                  groupBoxState[subqchoice.parentquestionpath][
                    subqchoice.questionpath
                  ]
                    ? groupBoxState[subqchoice.parentquestionpath][
                        subqchoice.questionpath
                      ]
                    : null
                }
                handleChange={
                  readOnly
                    ? undefined
                    : (event: any) => {
                        handleDateChange(
                          event,
                          depthLevel,
                          subqchoice.parentquestionpath,
                          subqchoice.questionpath,
                        );
                      }
                }
              />
              {subMenu}
            </li>
          </ElementDiv>
        );
      case signature:
        return (
          <ElementDiv key={`list-${subqchoice.id}`}>
            <li key={`li-${subqchoice.id}`}>
              <FormSignature
                readOnly={readOnly}
                subqchoice={subqchoice}
                handleValidate={
                  readOnly
                    ? undefined
                    : (event: any) =>
                        handleURLChange(
                          event,
                          subqchoice.parentquestionpath,
                          subqchoice.questionpath,
                        )
                }
                handleClear={
                  readOnly
                    ? undefined
                    : () =>
                        handleURLClear(
                          subqchoice.parentquestionpath,
                          subqchoice.questionpath,
                        )
                }
              />
              {subMenu}
            </li>
          </ElementDiv>
        );
      case map:
        return (
          <ElementDiv key={`list-${subqchoice.id}`} id="pain-point">
            <li key={`li-${subqchoice.id}`}>
              <PainMap
                readOnly={readOnly}
                subqchoice={subqchoice}
                handleValidate={
                  readOnly
                    ? undefined
                    : (event: any) =>
                        handleURLChange(
                          event,
                          subqchoice.parentquestionpath,
                          subqchoice.questionpath,
                        )
                }
                handleClear={
                  readOnly
                    ? undefined
                    : () =>
                        handleURLClear(
                          subqchoice.parentquestionpath,
                          subqchoice.questionpath,
                        )
                }
              />
              {subMenu}
            </li>
          </ElementDiv>
        );
      case radio:
        return (
          <ElementDiv key={`list-${subqchoice.id}`}>
            {subqchoice.isdcable && (
              <DCButton
                radio
                key={`field-${subqchoice.id}`}
                disabled={
                  !!dcGroupBoxState[subqchoice.questionpath] || readOnly
                }
                handleChange={
                  readOnly
                    ? undefined
                    : () => {
                        handleDCChange(
                          depthLevel,
                          subqchoice.parentquestionpath,
                          subqchoice.questionpath,
                        );
                      }
                }
              />
            )}
            <FullWidthLi key={`li-${subqchoice.id}`}>
              <RadioField
                key={`field-${subqchoice.id}`}
                subqchoice={subqchoice}
                readOnly={readOnly}
                checked={
                  (groupBoxState[subqchoice.parentquestionpath] &&
                    groupBoxState[subqchoice.parentquestionpath][
                      subqchoice.questionpath
                    ]) ||
                  false
                }
                submittedState={submitGroupBoxState}
                disabledState={disabledState}
                required={reqQuest && subqchoice.required}
                // any of the peer radio element is checked?
                // todo write function
                radioChecked={
                  (groupBoxState[subqchoice.parentquestionpath] &&
                    !!Object.keys(groupBoxState[subqchoice.parentquestionpath])
                      .length &&
                    some(
                      Object.keys(groupBoxState[subqchoice.parentquestionpath]),
                      (x) => controlTypeState[x] === radio,
                    ) &&
                    some(
                      Object.values(
                        groupBoxState[subqchoice.parentquestionpath],
                      ),
                      (x) => x === true,
                    )) ||
                  false
                }
                handleChange={
                  readOnly
                    ? undefined
                    : (event: any) => {
                        handleRadioChange(event, depthLevel, subqchoice);
                      }
                }
              />

              {subMenu}
            </FullWidthLi>
          </ElementDiv>
        );
      // single select cannot be DC
      case singleselect:
        return (
          <ElementDiv key={`list-${subqchoice.id}`}>
            {subqchoice.isdcable && (
              <DCButton
                radio
                key={`field-${subqchoice.id}`}
                disabled={
                  !!dcGroupBoxState[subqchoice.questionpath] || readOnly
                }
                handleChange={
                  readOnly
                    ? undefined
                    : () => {
                        handleDCChange(
                          depthLevel,
                          subqchoice.parentquestionpath,
                          subqchoice.questionpath,
                        );
                      }
                }
              />
            )}
            <FullWidthLi key={`li-${subqchoice.id}`}>
              <SelectField
                key={`field-${subqchoice.id}`}
                subqchoice={subqchoice}
                readOnly={readOnly}
                checked={
                  (groupBoxState[subqchoice.parentquestionpath] &&
                    groupBoxState[subqchoice.parentquestionpath][
                      subqchoice.questionpath
                    ] &&
                    groupBoxState[subqchoice.questionpath]) ||
                  {}
                }
                handleChange={
                  readOnly
                    ? undefined
                    : (event: any) => {
                        handleSelectChange(
                          event,
                          depthLevel,
                          subqchoice.questionpath,
                        );
                      }
                }
              />

              {subMenu}
            </FullWidthLi>
          </ElementDiv>
        );
      // multi select cannot be DC
      case multiselect:
        return (
          <ElementDiv key={`list-${subqchoice.id}`}>
            {subqchoice.isdcable && (
              <DCButton
                radio
                key={`field-${subqchoice.id}`}
                disabled={
                  !!dcGroupBoxState[subqchoice.questionpath] || readOnly
                }
                handleChange={
                  readOnly
                    ? undefined
                    : () => {
                        handleDCChange(
                          depthLevel,
                          subqchoice.parentquestionpath,
                          subqchoice.questionpath,
                        );
                      }
                }
              />
            )}
            <FullWidthLi key={`li-${subqchoice.id}`}>
              <MultiSelectField
                key={`field-${subqchoice.id}`}
                subqchoice={subqchoice}
                readOnly={readOnly}
                checked={
                  (groupBoxState[subqchoice.parentquestionpath] &&
                    groupBoxState[subqchoice.parentquestionpath][
                      subqchoice.questionpath
                    ] &&
                    groupBoxState[subqchoice.questionpath]) ||
                  {}
                }
                handleChange={
                  readOnly
                    ? undefined
                    : (event: any) => {
                        handleMultiSelectChange(
                          event,
                          depthLevel,
                          subqchoice.questionpath,
                        );
                      }
                }
              />

              {subMenu}
            </FullWidthLi>
          </ElementDiv>
        );
      case checkbox:
        return (
          <ElementDiv key={`list-${subqchoice.id}`} id="cpp-checkbox">
            {subqchoice.isdcable && (
              <DCButton
                key={`field-${subqchoice.id}`}
                disabled={
                  !!dcGroupBoxState[subqchoice.questionpath] || readOnly
                }
                handleChange={
                  readOnly
                    ? undefined
                    : () => {
                        handleDCChange(
                          depthLevel,
                          subqchoice.parentquestionpath,
                          subqchoice.questionpath,
                        );
                      }
                }
              />
            )}
            <FullWidthLi key={`li-${subqchoice.id}`}>
              <CheckBoxField
                key={`field-${subqchoice.id}`}
                subqchoice={subqchoice}
                readOnly={readOnly}
                submittedState={submitGroupBoxState}
                disabledState={disabledState}
                checked={
                  (groupBoxState[subqchoice.parentquestionpath] &&
                    groupBoxState[subqchoice.parentquestionpath][
                      subqchoice.questionpath
                    ]) ||
                  false
                }
                // @note may be needed
                required={reqQuest && subqchoice.required}
                // any of the peer checkbox element is checked?
                checkboxChecked={
                  subqchoice.rule === isonerequired
                    ? (groupBoxState[subqchoice.parentquestionpath] &&
                        some(
                          Object.values(
                            groupBoxState[subqchoice.parentquestionpath],
                          ),
                          (x) => x === true,
                        )) ||
                      false
                    : false
                }
                handleChange={
                  readOnly
                    ? undefined
                    : (event: any) => {
                        handleCheckboxChange(
                          event,
                          depthLevel,
                          subqchoice.parentquestionpath,
                          subqchoice.questionpath,
                        );
                      }
                }
              />

              {subMenu}
            </FullWidthLi>
          </ElementDiv>
        );
      default:
        return (
          <ElementDiv key={`list-${subqchoice.id}`} id="cpp-default">
            <FormLi
              key={`li-${subqchoice.id}`}
              id="cpp-li-default"
              horizontal={subqchoice.drawmode === horizontal}
              bullet={subqchoice.cssclass === 'bullet'}
            >
              <StatementField
                key={`field-${subqchoice.id}`}
                subqchoice={subqchoice}
              />
              {subMenu}
            </FormLi>
          </ElementDiv>
        );
    }
  };

  const renderSubMenu = (
    subqchoices: any,
    depthLevel = 0,
    isHorizontal?: boolean,
    subLevel?: boolean,
  ) => {
    const menuOptions = subqchoices.map((subqchoice: any) => {
      const hasOptions =
        subqchoice &&
        subqchoice.subqchoices &&
        subqchoice.subqchoices.length > 0 &&
        subqchoice.subqchoices[0] !== null;

      // isHorizontalMode should be for input/singleselect/multiselect

      // Forms that do not follow this pattern are
      // **ALTERATION IN NEURO**
      // **SPIRITUAL DISCOMFORT**
      // **SAFETY/SELF CARE DEFICIT**
      const isHorizontalMode = subqchoice.drawmode === horizontal;

      let subMenu;

      // auto_unroll to unroll
      // the option is not clicked so no handleChange function => autoUnroll
      if (subqchoice.autounroll) {
        const { parentquestionpath, questionpath } = subqchoice;

        const newDepthLevel = depthLevel + 1;
        autoUnroll(depthLevel, parentquestionpath, questionpath);

        /**
         * LOGIC for the labels expanding and un-expanding
         */

        if (
          selectedIds[depthLevel] &&
          selectedIds[depthLevel].length &&
          hasOptions
        ) {
          subMenu = renderSubMenu(
            subqchoice.subqchoices,
            newDepthLevel,
            isHorizontalMode,
          );
        }
      }

      /**
       * only render selected submenu and only if nested options exist
       * LOGIC for the labels expanding and un-expanding
       */

      /**
       *selectedIds and depth level to look at
       */

      // @note prblem displaying subsction at Level 1

      const goGenLevelDown =
        groupBoxState &&
        selectedIds &&
        selectedIds[depthLevel] &&
        (selectedIds[depthLevel].indexOf(subqchoice.questionpath) > -1 ||
          subqchoice.questionlabel === 'Other') &&
        groupBoxState[subqchoice.parentquestionpath] &&
        groupBoxState[subqchoice.parentquestionpath][subqchoice.questionpath] &&
        hasOptions;

      const goSubLevelDown =
        groupBoxState &&
        selectedIds &&
        selectedIds[depthLevel] &&
        groupBoxState[subqchoice.parentquestionpath] &&
        groupBoxState[subqchoice.parentquestionpath][subqchoice.questionpath] &&
        hasOptions;

      const levelDown = subLevel ? goSubLevelDown : goGenLevelDown;

      if (levelDown) {
        const newDepthLevel = depthLevel + 1;

        subMenu = renderSubMenu(
          subqchoice.subqchoices,
          newDepthLevel,
          isHorizontalMode,
          subLevel,
        );
      }

      return renderField(subqchoice, depthLevel, subMenu);
    });

    return (
      <div key={`div-key-${depthLevel}`} id="cpp-high">
        {/* <FormLabel component="legend">Related to</FormLabel> */}
        <div id="cpp-low">
          <StyledUl className="cpp-ul" horizontal={isHorizontal}>
            <>{menuOptions}</>
          </StyledUl>
        </div>
      </div>
    );
  };

  const [subData, setSubData] = useState<any>(null);
  const [subDataL1, setSubDataL1] = useState<any>(null);
  const [showAllData, setShowAllData] = useState<any>(null);
  const classes = useStyles();

  const getTopUI = (data: any) => {
    if (
      labelState &&
      groupBoxState &&
      updatedData &&
      Object.keys(groupBoxState)[0] === Object.keys(initGroupBoxState)[0]
    ) {
      const toporder = true;
      return getSubUI(data, toporder);
    }
    return (
      <div>
        {defaults.loadingForm}
        <LinearProgress />
      </div>
    );
  };
  // labelState and groupBoxState part of the drawing logic
  const getFormUI = (data: any, subLevel?: boolean) => {
    const isHorizontalMode =
      data && data.length && data[0].parentdrawmode === horizontal;
    return data &&
      data.length &&
      labelState &&
      groupBoxState &&
      Object.keys(groupBoxState)[0] === Object.keys(initGroupBoxState)[0] &&
      renderSubMenu(data) ? (
      <div key={`engine${reloadKey}`}>
        {renderSubMenu(data, 0, isHorizontalMode, subLevel)}
      </div>
    ) : (
      <div>
        {defaults.loadingForm}
        <LinearProgress />
      </div>
    );
  };
  const maxButtonCount: number = (window.env?.formMaxButtons as number) || 8;
  const [buttonState, setButtonState] = useState<any>(null);
  const [buttonMinView, setButtonMinView] = useState<boolean>(false);
  const [buttonHeight, setButtonHeight] = useState<number | null>(0);

  useEffect(() => {
    if (updatedData && updatedData.length > maxButtonCount) {
      setButtonMinView(true);
    }
  }, [updatedData && updatedData.length]);

  // when clicking on ALL SECTIONS re-calculate the sticky height
  useEffect(() => {
    if (buttonState === false) {
      const stickyEl = document.getElementById(topFormSectionID);
      const stickyElHeight = stickyEl && stickyEl.offsetHeight;
      setButtonHeight(stickyElHeight);
    } else if (buttonState === true) {
      setButtonHeight(null);
    }
  }, [buttonState]);

  const getButtonClass = (x: any, data: any, isTopOrder: boolean) => {
    let buttonClass;
    let required = reqQuest && x.required;
    const disabled = disabledState[x.questionpath];
    const requiredDis = required && disabled;
    if (requiredDis) {
      required = false;
    }
    const testPassed = checkRequired(
      x.subqchoices,
      submitGroupBoxState,
      disabledState,
    );
    // if button clicked
    if (data && data[0] && data[0].parentquestion_id === x.id && !showAllData) {
      if (required && !testPassed) {
        buttonClass = classes.selectedRequiredButton;
      } else {
        buttonClass = classes.selectedButton;
      }
    } else if (buttonState && buttonMinView && isTopOrder) {
      buttonClass = classes.buttonHide;
    } else if (required) {
      if (testPassed) {
        buttonClass = classes.successButton;
      } else if (hasBeenClicked(submitButtonState, x.questionpath)) {
        buttonClass = classes.successRequiredButton;
      } else {
        buttonClass = classes.requiredButton;
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (hasBeenClicked(submitButtonState, x.questionpath)) {
        buttonClass = classes.successButton;
      } else {
        buttonClass = classes.regularButton;
      }
    }
    return buttonClass;
  };

  const getSeeAllButtonClass = () => {
    let buttonClass;
    if (subData && subData[0].id === updatedData[0].id && showAllData) {
      buttonClass = classes.selectedButton;
    } else if (buttonState && buttonMinView) {
      buttonClass = classes.buttonHide;
    } else {
      buttonClass = classes.regularButton;
    }
    return buttonClass;
  };

  const getSubUI = (data: any, toporder?: boolean) => {
    const isTopOrder = data && data.length && data[0].toporder === 1;
    const buttonWidth = data[0].width ? data[0].width * widthMultiplier : null;
    const stickyEl = document.getElementById(topFormSectionID);
    const stickyElHeight = stickyEl && stickyEl.offsetHeight;
    if (data) {
      const entireFormButton = (
        <Button
          type="submit"
          variant="outlined"
          size="small"
          key="entireFormButton"
          onClick={() => {
            setSubData(updatedData);
            setShowAllData(true);
            setButtonState(true);
          }}
          color="primary"
          classes={{
            root: getSeeAllButtonClass(),
          }}
          style={{
            width: buttonWidth ? `${buttonWidth}px` : 'auto',
            minWidth: '80px',
          }}
        >
          ENTIRE FORM
        </Button>
      );
      const allSectionButton = (
        <Button
          type="submit"
          variant="outlined"
          size="small"
          key="allSectionButton"
          onClick={() => {
            setButtonState(false);
          }}
          color="primary"
          classes={{
            root:
              buttonState && buttonMinView
                ? classes.regularButton
                : classes.buttonHide,
          }}
          style={{
            width: buttonWidth ? `${buttonWidth}px` : 'auto',
            minWidth: '80px',
          }}
        >
          ALL SECTIONS
        </Button>
      );
      if (data.length > 1) {
        const titles = data.map((x: any) => (
          <Button
            type="submit"
            variant="outlined"
            size="small"
            key={x.id}
            onClick={() => {
              updateSubmitState(x);
              if (isTopOrder) {
                setSubData(x.subqchoices);
                setSubDataL1(null);
              } else {
                setSubDataL1(x.subqchoices);
              }
              setShowAllData(false);
              setButtonState(true);
            }}
            color="primary"
            classes={{
              root: isTopOrder
                ? getButtonClass(x, subData, isTopOrder)
                : getButtonClass(x, subDataL1, isTopOrder),
            }}
            style={{
              width: x.width ? `${x.width * widthMultiplier}px` : 'auto',
            }}
          >
            {x.questionlabel}
          </Button>
        ));

        const alltitles = toporder
          ? [...titles, entireFormButton, allSectionButton]
          : [...titles];
        const Div: any = toporder ? TitleDiv : StickyTitleDiv;
        return (
          <Div id="resume-form" stickyElHeight={buttonHeight || stickyElHeight}>
            {alltitles}
          </Div>
        );
      }
      return <TitleDiv id="resume-form">{[entireFormButton]}</TitleDiv>;
    }
    return (
      <div>
        {defaults.loadingForm}
        <LinearProgress />
      </div>
    );
  };

  const getSubUIL1 = () => {
    const istitleUI = subDataL1 && isTitleUI(subDataL1);
    const subLevel = true;
    return (
      <>{istitleUI ? getSubUI(subDataL1) : getFormUI(subDataL1, subLevel)}</>
    );
  };

  const getUI = () => {
    if (subData && !showAllData) {
      const istitleUI = isTitleUI(subData);
      const subLevel = true;

      return (
        <>
          {istitleUI ? getSubUI(subData) : getFormUI(subData, subLevel)}
          {subDataL1 && getSubUIL1()}
        </>
      );
    }

    return <></>;
  };
  const noTopSection =
    (updatedData && updatedData.length === 1) ||
    isElectionAddendumForm({
      formkey: formData?.formkey,
      formname: formName,
      name: formData?.name,
    }) ||
    formName === HospiceElectionStatement;

  const getMainUI = () =>
    updatedData && noTopSection ? (
      <FormBody id="form-rendered-body">
        {isLoading && <SavingDiv id="saving-form">{defaults.saving}</SavingDiv>}
        <TopFormSection id={topFormSectionID}></TopFormSection>
        {getFormUI(updatedData)}
      </FormBody>
    ) : (
      <FormBody id="form-rendered-body">
        {isLoading && <SavingDiv id="saving-form">{defaults.saving}</SavingDiv>}
        <TopFormSection id={topFormSectionID}>
          {getTopUI(updatedData)}
        </TopFormSection>
        {getUI()}

        {subData && showAllData && getFormUI(subData)}
      </FormBody>
    );

  const topRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (topRef.current) {
      const target: any = topRef.current;
      target.scrollIntoView();
    }
  }, [topRef.current, subData && subData[0].id]);

  return (
    <div ref={topRef}>
      <FormPrompt hasUnsavedChanges={formModified} />
      {isLoading && <Loader />}
      {getMainUI()}
    </div>
  );
};

export default FormRenderer;
